import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { propFunc, propStr, } from '../../../../../../../helpers/custom-prop-types';
import SlideSearchTitleIcon from '../../../../../../Icon/Svg/SlideSearchTitleIcon';
const SlideSearchHeaderSideMenuSpHeader = (props) => {
    const { className, hideMenu } = props;
    return (_jsxs("div", Object.assign({ className: clsx('slide_search_header_side_menu_sp_header', className) }, { children: [_jsx(Link, Object.assign({ className: 'header_logo', to: '/proffit_search' }, { children: _jsx(SlideSearchTitleIcon, { className: 'logo_svg color' }) })), _jsx("button", Object.assign({ className: 'header_close', onClick: hideMenu, type: 'button' }, { children: _jsx(CloseIcon, { className: 'close_svg' }) }))] })));
};
SlideSearchHeaderSideMenuSpHeader.propTypes = {
    className: propStr(),
    hideMenu: propFunc().isRequired,
};
SlideSearchHeaderSideMenuSpHeader.defaultProps = {
    className: '',
};
export default SlideSearchHeaderSideMenuSpHeader;
